// AdminBanner.js
// Persistent banner shown when admin is viewing a family's data

import React from 'react';
import { useAdmin } from '../contexts/AdminContext';

function AdminBanner() {
  const { isInAdminView, viewingFamilyId, viewingFamilyData, exitAdminView } = useAdmin();

  if (!isInAdminView) {
    return null;
  }

  const familyName = viewingFamilyData?.name || 'Unknown';

  return (
    <div className="admin-banner">
      <div className="admin-banner-content">
        <span className="admin-banner-icon">🔧</span>
        <span className="admin-banner-text">
          Admin: viewing <strong>{familyName}</strong>
          <span className="admin-banner-id">({viewingFamilyId})</span>
        </span>
      </div>
      <button
        className="admin-banner-exit"
        onClick={exitAdminView}
      >
        Exit
      </button>
    </div>
  );
}

export default AdminBanner;
